import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '../../lib/styles';
import SeverityIcon from './SeverityIcon';
import Close from './Close';

const useStyle = makeStyles({
  root: {
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.08)',
  },
  message: {
    flex: 1,
    color: 'black',
    fontSize: '14px',
    padding: 0,
  },
  action: {
    height: '32px',
  },
});

const Toast = forwardRef(function Toast(props, ref) {
  const { onClose, isCloseable, severity, message, open, action, ...restProps } = props;
  const { root, ...styles } = useStyle();
  return (
    <Snackbar
      ContentProps={{
        classes: {
          root,
          ...styles,
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      ref={ref}
      {...restProps}
      action={action}
      severity={severity}
      open={open}
      onClose={onClose}
      message={
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              align: 'center',
              borderRadius: '5px',
              height: '24px',
            }}
          >
            <SeverityIcon severity={severity} />
            <div style={{ marginRight: '24px' }}>{message}</div>
            <div style={{ marginLeft: '0.3em' }}>
              {isCloseable && (
                <IconButton
                  style={{
                    border: 'none',
                    outline: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    padding: 0,
                    backgroundColor: 'transparent',
                  }}
                  aria-label="close"
                  type="button"
                  onClick={onClose}
                >
                  <Close viewBox="0 0 18 18" />
                </IconButton>
              )}
            </div>
          </div>
        </>
      }
    />
  );
});

Toast.propTypes = {
  severity: Proptypes.oneOf(['error', 'success', 'default']),
  message: Proptypes.string.isRequired,
  open: Proptypes.bool.isRequired,
  action: Proptypes.node,
  isCloseable: Proptypes.bool,
  onClose: Proptypes.func.isRequired,
};

Toast.defaultProps = {
  severity: 'default',
  action: null,
  isCloseable: true,
};

Toast.displayName = 'Toast';

export default Toast;
